import React from 'react';
import { SupportedCardGalleryItemProps } from './SupportedCardGalleryItemProps';

type RenderItemRawProps = Omit<
  Partial<SupportedCardGalleryItemProps>,
  'title' | 'subtitle>'
>;

type CardsGridPresetFullProps<T, P> = P & {
  preset: 'full';
  renderItem?: (
    item: T,
    index: number,
  ) => RenderItemRawProps & {
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
  };
};

type CardsGridPresetTitleProps<T, P> = P & {
  preset?: 'title';
  renderItem?: (
    item: T,
    index: number,
  ) => RenderItemRawProps & {
    title?: React.ReactNode;
    subtitle?: undefined;
  };
};

type CardsGridPresetEmptyProps<T, P> = P & {
  preset: 'empty';
  renderItem?: (
    item: T,
    index: number,
  ) => RenderItemRawProps & {
    title?: undefined;
    subtitle?: undefined;
  };
};

type CardsGridPresetGenericProps<T, P> = P & {
  preset?: 'full' | 'title' | 'empty';
  renderItem?: (
    item: T,
    index: number,
  ) => RenderItemRawProps & {
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
  };
};

export type CardsGridPresetProps<T, P> =
  | CardsGridPresetFullProps<T, P>
  | CardsGridPresetTitleProps<T, P>
  | CardsGridPresetEmptyProps<T, P>
  | CardsGridPresetGenericProps<T, P>;
